import React, { useEffect, useState } from "react";
import { ConfigProvider, Pagination, Typography } from "antd";
import { useLocation } from "wouter";
import { useDispatch } from "react-redux";
import Alertify from "../../../../services/alertify";
import CommonAdminTable from "../../../components/commonTable";
import { getQueryParams } from "../../../../utilities/getQueryParams";
import { SubOrdersDetailsAPI } from "../../../../redux/actions/adminActions/orderDetailsAction";

const { Title } = Typography;

const SubOrdersDetails = () => {
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const subOrderId = params.subOrderId;
  const initialPage = params.page || 1;

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalOrders, setTotalOrders] = useState(0);
  const [allSubOrders, setAllSubOrders] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Orders: ALP Shop";
  }, []);
  useEffect(() => {
    const data = {
      currentPage: currentPage,
      perPage: 10,
      sub_order_id: subOrderId,
    };
    if (subOrderId) {
      dispatch(SubOrdersDetailsAPI(data))
        .then((response) => {
          if (
            response.payload &&
            response.payload.data &&
            response.payload.data.data
          ) {
            const subOrdersWithIndex = response.payload.data.data.map(
              (product, index) => ({
                ...product,
                key: product.sub_order_id || index,
                index: index + 1 + (currentPage - 1) * 10,
              })
            );
            setAllSubOrders(subOrdersWithIndex);
            const total = response.payload.data.pagination.total || 0;
            setTotalOrders(total);
            console.log("All Sub Orders are:+++", subOrdersWithIndex);
          } else {
            throw new Error("Unexpected API response structure");
          }
        })
        .catch((error) => {
          Alertify.error(
            "Failed to fetch the all products list: " + error.message
          );
        });
    }
  }, [currentPage, dispatch, subOrderId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(
      `/admin/orders/sub-order-details?subOrderId=${subOrderId}&page=${page}`
    );
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      align: "center",
    },
    {
      title: "Item Code",
      dataIndex: "erp_item_code",
      key: "erp_item_code",
      align: "center",
    },
    {
      title: "Quantity To Ship",
      dataIndex: "quantity_to_ship",
      key: "quantity_to_ship",
      align: "center",
    },
    {
      title: "Branch Code",
      dataIndex: "branch_code",
      align: "center",
      key: "branch_code",
    },
    {
      title: "Requested Delivery Date",
      dataIndex: "requested_delivery_date",
      key: "requested_delivery_date",
      align: "center",
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   align: "center",
    //   render: (record) => (
    //     <Space size="middle">
    //       <Link
    //         // to={`/admin/orders/sub-order-details?subOrderId=${record.sub_order_id}`}
    //         to="#"
    //         className="text-red-600"
    //       >
    //         <EyeFilled className="me-2" />
    //         View
    //       </Link>
    //     </Space>
    //   ),
    // },
  ];

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Typography: {
              titleMarginBottom: 0,
              titleMarginTop: 0,
            },
          },
        }}
      >
        <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
          <div className="sm:w-1/3">
            <Title level={2} className="text-left p-0 m-0">
              {subOrderId}
            </Title>
          </div>
        </div>
      </ConfigProvider>
      <CommonAdminTable columns={columns} data={allSubOrders} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalOrders}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
};

export default SubOrdersDetails;
